/** @format */
import * as yup from "yup";



export const socialsSchema = yup.object().shape({
  facebook: yup.string().nullable(),
  twitter: yup.string().nullable(),
  pinterest: yup.string().nullable(),
  instagram: yup.string().nullable(),
  youtube: yup.string().nullable(),
  linkedin: yup.string().nullable(),
});
